//import logo from './logo.svg';
import React from 'react';
//import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Home, About, Contact, Services, NoPage } from './Pages';
import './App.css';

function App() {
  return (
    <Router>
       <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/o-nama" element={<About />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path='/servisi' element={<Services />} />
          <Route path="/*" element={<NoPage />} />
       </Routes>
    </Router>
   
  );
}

export default App;
